import { render } from "./HomeBooking.vue?vue&type=template&id=35016884"
import script from "./HomeBooking.vue?vue&type=script&lang=js"
export * from "./HomeBooking.vue?vue&type=script&lang=js"

import "./HomeBooking.vue?vue&type=style&index=0&id=35016884&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__